/* global App */
const BaseRouter = require('./base')
const views = require('./views')

module.exports = BaseRouter.extend({
    initialize () {
        // User
        // Change email
        this.routings.push({
            key: 'accountConfirm',
            path: new RegExp(`${App.urlRegexTo('account/update-email')}.*$`),
            view: views.AccountCounterView,
        })

        this.routings.push({
            key: 'accountConfirm',
            path: new RegExp(`${App.urlRegexTo('user/account/confirm')}.*$`),
            view: views.AccountCounterView,
        })

        this.routings.push({
            key: 'accountUnsubscribe',
            path: new RegExp(`${App.urlRegexTo('user/account/unsubscribe-from-commercials')}.*$`),
            view: views.AccountCounterView,
        })

        this.routings.push({
            key: 'accountEdit',
            path: new RegExp(`${App.urlRegexTo('account/edit')}.*$`),
            view: views.AccountEditView,
        })

        this.routings.push({
            key: 'userPreferences',
            path: new RegExp(`${App.urlRegexTo('user-preferences/auto-deposit')}.*$`),
            view: views.UserPreferencesView,
        })

        this.routings.push({
            key: 'requestPasswordReset',
            path: new RegExp(`${App.urlRegexTo('account/request-password-reset')}.*$`),
            view: views.AccountRequestPasswordResetView,
        })
        this.routings.push({
            key: 'resetPassword',
            path: new RegExp(App.urlRegexTo('user/account/reset-password')),
            view: views.AccountResetPasswordView,
        })

        // Ser ticket
        this.routings.push({
            key: 'serTicketShow',
            path: new RegExp(`${App.urlRegexTo('ser-ticket/show')}.*$`),
            view: views.SerTicketShowView,
        })

        this.routings.push({
            key: 'serTicketShow',
            path: new RegExp(`${App.urlRegexTo('ser-ticket/new')}.*$`),
            view: views.SerTicketShowView,
        })

        this.routings.push({
            key: 'serTicketShow',
            path: new RegExp(`${App.urlRegexTo('ser-ticket/pay')}.*$`),
            view: views.SerTicketPayView,
        })

        this.routings.push({
            key: 'serTicketUnpark',
            path: new RegExp(`${App.urlRegexTo('ser-ticket/unpark')}.*$`),
            view: views.SerTicketUnparkView,
        })

        this.routings.push({
            key: 'kioskResetPassword',
            path: new RegExp(App.urlRegexTo('kiosk/reset-password')),
            view: views.KioskResetPasswordView,
        })

        this.generateRoutes()
    },
})
